import { PaperclipIcon } from '@/icons';
import type { FormListFieldData } from 'antd';
import { Flex, Form, InputNumber, Radio } from 'antd';
const Answer = ({ field }: { field: FormListFieldData }) => {
  const form = Form.useFormInstance();
  const answerData = Form.useWatch(['answers', field.name], form);

  const question = answerData?.question;
  const questionType = question?.question_type;

  const renderAnswerContent = () => {
    if (!questionType) return null;

    switch (questionType) {
      case 'mcq':
        return (
          <div className="mt-6 p-6 rounded-lg border border-theme-gray-700 space-y-4">
            {question?.options?.map((option: any) => {
              const isCorrect = option.is_correct;
              const isSelected =
                answerData?.answer_text === option.value || isCorrect;

              let textColor = 'text-white';
              if (isCorrect) {
                textColor = 'text-teal-500 font-bold';
              } else if (isSelected && !isCorrect) {
                textColor = 'text-rose-500 font-bold';
              }

              return (
                <Flex gap={16} key={option.id} align="center">
                  <Radio disabled checked={isSelected} />
                  <span className={textColor}>{option.value}</span>
                </Flex>
              );
            })}
          </div>
        );
      case 'text':
        return (
          <div className="mt-6 p-4 rounded-lg border border-theme-gray-700 text-base text-white">
            {answerData?.answer_text || 'No answer provided'}
          </div>
        );
      case 'attachment':
        return (
          <div className="mt-6 p-3 rounded-lg border border-theme-gray-700 flex items-center gap-4">
            <PaperclipIcon size={20} className="text-theme-primary" />
            <a
              href={answerData?.answer_attachment}
              target="_blank"
              rel="noreferrer"
              className="bg-[#DBDBDB] rounded pl-1 pr-2 text-theme-gray-800 flex items-center gap-1 cursor-pointer"
            >
              <PaperclipIcon size={16} className="rotate-45 text-[#007FC4]" />
              {answerData?.answer_attachment?.split('/').pop() ||
                'Attachment.pdf'}
            </a>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="border-b border-b-white/60 pb-6 border-dashed last:border-0 last:pb-0">
      <Flex gap={24} justify="space-between" align="start">
        <div className="!w-full !grow">
          <label className="text-theme-gray-300 block mb-2">
            Question {field.name + 1}
          </label>
          <span className="text-base text-white font-medium">
            {question?.title || 'Question Title'}
          </span>
        </div>

        <div className="w-20 shrink-0">
          <label className="text-theme-gray-300 block mt-2.5">Full Mark</label>
          <span className="text-base text-white block mt-1 font-medium p-3 h-[46px]">
            {answerData?.mark || question?.mark || 0}
          </span>
        </div>

        <Form.Item
          label="Mark"
          name={[field.name, 'obtained_mark']}
          className="w-24 shrink-0"
          rules={[
            { required: true, message: '[Required]' },
            { type: 'number', min: 0, message: '[Negative]' },
            {
              validator: (_, value) => {
                if (value > Number(question?.mark)) {
                  return Promise.reject(new Error(`Max ${question?.mark}`));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <InputNumber type="number" placeholder="0" controls={false} />
        </Form.Item>
      </Flex>

      {renderAnswerContent()}

      {/* <Form.Item
        label="Evaluator Comment"
        name={[field.name, 'evaluator_comment']}
        className="mt-6"
      >
        <Input.TextArea rows={3} placeholder="Enter your comment here..." />
      </Form.Item> */}
    </div>
  );
};

export default Answer;
